import apiClient from "./client";

export function getWeatherForecast(lat, lng, days = 5) {
  return apiClient.get("/weatherforecast", {
    params: { lat, lng, days },
  });
}

export function getCurrentWeather(lat, lng) {
  return apiClient.get("/weatherforecast/current", {
    params: { lat, lng },
  });
}

export function getWeatherAlerts(lat, lng) {
  return apiClient.get("/weatherforecast/alerts", {
    params: { lat, lng },
  });
}

export function getWeatherForZone(zoneId) {
  return apiClient.get(`/weatherforecast/zone/${encodeURIComponent(zoneId)}`);
}

export function getWeatherForAsset(assetId) {
  return apiClient.get(`/weatherforecast/asset/${assetId}`);
}

export function getMetEireannForecast(lat, lng) {
  return apiClient.get("/weatherforecast/met-eireann", {
    params: { lat, lng },
  });
}

export function getWeatherHistory(params = {}) {
  return apiClient.get("/weather-history", { params });
}

export function getWeatherMonitorPoints() {
  return apiClient.get("/weather-history/points");
}

export function saveWeatherMonitorPoint(payload) {
  return apiClient.post("/weather-history/points", payload);
}

export function deleteWeatherMonitorPoint(weatherMonitorPointId) {
  return apiClient.delete(`/weather-history/points/${weatherMonitorPointId}`);
}

export function captureWeatherNow() {
  return apiClient.post("/weather-history/capture-now");
}

